import { Response, apiAbortController } from '@ui/src';
import api from '../../../api/api';
import { RateItem, RateFormValues } from '../types';

export const exchangeRatesApi = api.injectEndpoints({
  endpoints: (build) => ({
    getExchangeRates: build.query<Response<RateItem>, string>({
      query: (query) => ({
        url: `/v1/rates${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRate: build.query<{ data: RateItem }, string>({
      query: (id) => ({
        url: `/v1/rates/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getRateHistoryDetails: build.query<{ data: RateItem }, string>({
      query: (id) => ({
        url: `/v1/rates/${id}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    createRate: build.mutation<
      {
        data: RateItem;
      },
      RateFormValues
    >({
      query: (data) => ({
        url: '/v1/rates',
        method: 'POST',
        body: data,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    updateRate: build.mutation<
      {
        data: RateItem;
      },
      { body: Partial<RateFormValues>; id: string }
    >({
      query: (data) => ({
        url: `/v1/rates/${data.id}`,
        method: 'PUT',
        body: data.body,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
    getExchangePairRates: build.query<Response<RateItem>, string>({
      query: (query) => ({
        url: `/v1/rates?${query}`,
        signal: apiAbortController.getSignalToken(),
      }),
    }),
  }),
});

export const {
  useLazyGetExchangeRatesQuery,
  useCreateRateMutation,
  useUpdateRateMutation,
  useLazyGetRateQuery,
  useLazyGetExchangePairRatesQuery,
  useLazyGetRateHistoryDetailsQuery,
} = exchangeRatesApi;

export const {
  endpoints: {
    getExchangeRates,
    createRate,
    updateRate,
    getRate,
    getExchangePairRates,
    getRateHistoryDetails,
  },
} = exchangeRatesApi;
